var SelectInfoBannerModule = /** @class */ (function () {
    function SelectInfoBannerModule() {
    }
    return SelectInfoBannerModule;
}());
export { SelectInfoBannerModule };
